import { useCallback } from 'react';

import { CREATE_JOB_NOTIFICATION_DEFERMENT_MUTATION } from 'src/graphql/jobNotificationDeferments/mutation';
import { useMutation } from 'src/graphql';

export const useJobNotificationCreateDeferment = () => {
  const [createJobNotificationDeferment] = useMutation(CREATE_JOB_NOTIFICATION_DEFERMENT_MUTATION);

  return useCallback(
    ({ jobId }) => createJobNotificationDeferment({
      variables: {
        jobId,
      },
    }),
    [],
  );
};
